var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25706 3.59858C9.02167 2.23928 10.9788 2.23928 11.7434 3.59858L17.3237 13.5191C18.0736 14.8523 17.1102 16.4996 15.5805 16.4996H4.4199C2.89025 16.4996 1.92682 14.8523 2.67675 13.5191L8.25706 3.59858ZM11.0001 13.4998C11.0001 14.052 10.5524 14.4998 10.0001 14.4998C9.44784 14.4998 9.00012 14.052 9.00012 13.4998C9.00012 12.9475 9.44784 12.4998 10.0001 12.4998C10.5524 12.4998 11.0001 12.9475 11.0001 13.4998ZM10.0001 5.49976C9.44784 5.49976 9.00012 5.94747 9.00012 6.49976V9.49976C9.00012 10.052 9.44784 10.4998 10.0001 10.4998C10.5524 10.4998 11.0001 10.052 11.0001 9.49976V6.49976C11.0001 5.94747 10.5524 5.49976 10.0001 5.49976Z",
    fill: "#F59E0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationYellow);
export default __webpack_public_path__ + "static/media/ExclamationYellow.ee9521fbda069f448353fa46885264c3.svg";
export { ForwardRef as ReactComponent };